<template>
  <footer class="footer">
    © 2026 福州仓山区千镜软件信息科技工作室 版权所有<br />
    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">闽ICP备2026023410号</a> |
    <a href="https://www.beian.gov.cn/" target="_blank" rel="noopener noreferrer">闽公网安备35010402351934号</a> |
    <a @click="showModal('privacy')"><i class="fas fa-shield-alt"></i> {{ $t('manga.footer.privacy') }}</a> |
    <a @click="showModal('agreement')"><i class="fas fa-file-contract"></i> {{ $t('manga.footer.agreement') }}</a> |
    <a @click="showModal('about')"><i class="fas fa-info-circle"></i> {{ $t('manga.footer.about') }}</a>
  </footer>
</template>

<script setup>
const emit = defineEmits(['show-modal'])

const showModal = (modalType) => {
  emit('show-modal', modalType)
}
</script>

<style scoped>
.footer {
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(15, 23, 42, 0.95);
  border-top: 1px solid rgba(94, 234, 212, 0.1);
  padding: 12px;
  text-align: center;
  z-index: 90;
  font-size: 0.85rem;
  color: #94a3b8;
  backdrop-filter: blur(10px);
}

.footer a {
  color: #5eead4;
  text-decoration: none;
  margin: 0 10px;
  cursor: pointer;
  transition: 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.footer a:hover {
  text-decoration: underline;
  color: #a78bfa;
}

.footer i {
  font-size: 0.85rem;
}
</style>